module.exports = __webpack_public_path__ + "static/media/oops.042f8844.svg";